const component = "site-section-appliances-summary";
const categoryItem = `${component}/category-item`;

export const siteSectionAppliancesSummary = {
  component,
  title: `${component}/title`,
  moveAppliancesButton: `${component}/move-appliances-button`,
  noApplianceText: `${component}/no-appliance-text`,
  categoryItem: `${component}/category`,
  categoryItemIcon: `${categoryItem}/category/icon`,
  categoryItemCount: `${categoryItem}/category/count`,
  seeAllButton: `${component}/see-all-button`,
  totalCount: `${component}/total-count-text`,
} as const;
